import { Link } from "react-router-dom";

export default function PropertyCard({ property, variant = "card" }) {
  const { id, categoria, titolo, descrizione, prezzo_label, badge, image_url, image_alt } = property;
  const detailUrl = `/immobile/${id}`;

  if (variant === "row") {
    return (
      <article
        data-testid={`property-card-${titolo.toLowerCase().replace(/\s+/g, "-")}`}
        className="bg-[var(--card)] border border-[var(--ink)]/10 rounded-lg p-6 flex flex-col sm:flex-row gap-6"
      >
        <Link to={detailUrl} data-testid={`property-open-${titolo.toLowerCase().replace(/\s+/g, "-")}`} className="relative sm:w-1/2 aspect-[4/3] rounded overflow-hidden flex-shrink-0 bg-[#eceae4] block group">
          <img src={image_url} alt={image_alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
          <span className="absolute bottom-3 left-3 font-mono-lbl text-[10px] uppercase text-[var(--ink)] bg-white/95 px-2 py-1 rounded">
            {badge}
          </span>
        </Link>
        <div className="flex-1 flex flex-col justify-between">
          <div>
            <span className="font-mono-lbl text-[11px] uppercase text-[var(--gold-deep)] font-semibold">{categoria}</span>
            <h3 className="font-display font-bold text-base text-[var(--ink)] mt-1">
              <Link to={detailUrl} className="hover:text-[var(--gold-deep)] transition-colors">{titolo}</Link>
            </h3>
            <p className="text-xs text-[var(--ink)]/70 mt-2">{descrizione}</p>
          </div>
          <div className="pt-4 border-t border-[var(--ink)]/10 flex items-center justify-between mt-4 font-mono-lbl">
            <span className="font-bold text-base text-[var(--ink)]">{prezzo_label}</span>
            <Link
              to={detailUrl}
              data-testid={`property-info-${titolo.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs text-[var(--gold-deep)] hover:underline uppercase"
            >
              Dettagli →
            </Link>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article
      data-testid={`property-card-${titolo.toLowerCase().replace(/\s+/g, "-")}`}
      className="bg-[var(--paper)] border border-[var(--ink)]/10 rounded-lg overflow-hidden flex flex-col"
    >
      <Link to={detailUrl} data-testid={`property-open-${titolo.toLowerCase().replace(/\s+/g, "-")}`} className="relative aspect-[4/3] bg-[#eceae4] block overflow-hidden group">
        <img src={image_url} alt={image_alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute bottom-4 left-4 font-mono-lbl text-[10px] uppercase bg-white/95 px-2 py-1 text-[var(--ink)] rounded">
          {badge}
        </span>
      </Link>
      <div className="p-6 flex-1 flex flex-col justify-between space-y-4">
        <div>
          <span className="font-mono-lbl text-xs uppercase text-[var(--gold-deep)] font-semibold">{categoria}</span>
          <h3 className="font-display font-bold text-lg text-[var(--ink)] mt-1">
            <Link to={detailUrl} className="hover:text-[var(--gold-deep)] transition-colors">{titolo}</Link>
          </h3>
          <p className="text-xs text-[var(--ink)]/70 mt-1">{descrizione}</p>
        </div>
        <div className="pt-4 border-t border-[var(--ink)]/10 flex items-center justify-between font-mono-lbl">
          <span className="font-bold text-base text-[var(--ink)]">{prezzo_label}</span>
          <Link
            to={detailUrl}
            data-testid={`property-contact-${titolo.toLowerCase().replace(/\s+/g, "-")}`}
            className="text-xs text-[var(--gold-deep)] hover:underline uppercase"
          >
            Dettagli →
          </Link>
        </div>
      </div>
    </article>
  );
}
